<ion-item-group>
  <ion-item-divider>
    <ion-label translate>Mobile.StatusChangeView</ion-label>
  </ion-item-divider>

  <app-settings-select-field [entry]="statusChangeViewPositionSettings"></app-settings-select-field>
</ion-item-group>
